import { Backdrop, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../store";

const GlobalLoader = () => {
  const loading = useSelector((state: RootState) => state.loader.loading);

  return (
    <Backdrop
      open={loading}
      sx={{ zIndex: (theme) => theme.zIndex.modal + 999 }}
    >
      <CircularProgress sx={{ color: "#f2674a"}} />
    </Backdrop>
  );
};

export default GlobalLoader;
